export const CHECKOUT_URL =
  'https://checkout.ebookpoint.shop/cart/59909265457233:1'

export const SUPPORT_EMAIL = 'EbookDreamShop@gmail.com'

export const META_PIXEL_ID = '1252242806993118'

export const IMAGES = {
  product:
    'https://cdn.magicpatterns.com/uploads/d4DeHSPobtJucoeSSdyVjJ/ChatGPT_Image_Jul_27,_2026,_01_11_48_AM.png',
  background:
    'https://cdn.magicpatterns.com/patterns/generated-images/18f03433-4fb2-46c3-a4c0-2f7f20c2c6b2.jpg',
  bonusPresupuesto:
    'https://cdn.magicpatterns.com/uploads/caRxUyJpQyqBnHkdxLUT1c/Bono_1_.png',
  bonusContratos:
    'https://cdn.magicpatterns.com/uploads/cDiMNBUeGF9CPUS7R9LtoW/Bono_2.png',
  bonusPlan:
    'https://cdn.magicpatterns.com/uploads/1uysGaQeTi4BiZtYYKACDc/Bono_3.png',
  bonusIlustraciones:
    'https://cdn.magicpatterns.com/uploads/ctN8U2DCJ4LkG1bqMEGtZL/Bono_4.png',
  bonusNinos:
    'https://cdn.magicpatterns.com/uploads/iBnini7WP8aR6JRiC6X6u5/Bono_5.png',
}

export function goToCheckoutSection(): void {
  const el = document.getElementById('compra')
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}
